import ResilientImg from "@/components/ui/ResilientImg";
import { useOptimizedImg } from "@/hooks/useOptimizedImg";

interface CardImageProps {
  src: string;
  alt: string;
  onError?: () => void;
  priority?: boolean | undefined;
  placeholder?: boolean;
}

export default function CardImage({ src, alt, onError, priority, placeholder }: CardImageProps) {
  const cardSrc = useOptimizedImg(src, "catalog");
  const thumbSrc = useOptimizedImg(src, "productThumb");

  if (placeholder) return <div className="relative h-[210px] w-full overflow-hidden rounded-t-xl bg-muted"><img src={src} alt={alt} width={400} height={210} loading={priority ? "eager" : "lazy"} className="h-full w-full object-contain" /></div>;
  return (
    <div className="relative h-[210px] w-full overflow-hidden rounded-t-xl bg-muted">
      <ResilientImg
        src={cardSrc}
        srcSet={`${thumbSrc} 100w, ${cardSrc} 400w`}
        sizes="(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 350px"
        alt={alt}
        width={400}
        height={210}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
        onError={onError}
        className="w-full h-full object-cover object-center"
      />
    </div>
  );
}
